// @ts-nocheck
// NOTE: fetch airports
export const FETCH_AIRPORTS_REQUEST = "FETCH_AIRPORTS_REQUEST";
export const FETCH_AIRPORTS_SUCCESS = "FETCH_AIRPORTS_SUCCESS";
export const FETCH_AIRPORTS_FAILURE = "FETCH_AIRPORTS_FAILURE";

// NOTE: add airport
export const ADD_AIRPORT_REQUEST = "ADD_AIRPORT_REQUEST";
export const ADD_AIRPORT_SUCCESS = "ADD_AIRPORT_SUCCESS";
export const ADD_AIRPORT_FAILURE = "ADD_AIRPORT_FAILURE";

// NOTE: update airport
export const UPDATE_AIRPORT_REQUEST = "UPDATE_AIRPORT_REQUEST";
export const UPDATE_AIRPORT_SUCCESS = "UPDATE_AIRPORT_SUCCESS";
export const UPDATE_AIRPORT_FAILURE = "UPDATE_AIRPORT_FAILURE";

// NOTE: delete airport
export const DELETE_AIRPORT_REQUEST = "DELETE_AIRPORT_REQUEST";
export const DELETE_AIRPORT_SUCCESS = "DELETE_AIRPORT_SUCCESS";
export const DELETE_AIRPORT_FAILURE = "DELETE_AIRPORT_FAILURE";

// NOTE: toggle airport status
export const TOGGLE_AIRPORT_STATUS_REQUEST = "TOGGLE_AIRPORT_STATUS_REQUEST";
export const TOGGLE_AIRPORT_STATUS_SUCCESS = "TOGGLE_AIRPORT_STATUS_SUCCESS";
export const TOGGLE_AIRPORT_STATUS_FAILURE = "TOGGLE_AIRPORT_STATUS_FAILURE";